<div class="dialog-header">
  <h6 matDialogTitle>Add Node Details</h6>
  <button
    class="close-button"
    bciprimarybutton
    tabindex="-1"
    (click)="close(false)"
  >
    <i class="Bosch-Ic Bosch-Ic-abort" aria-hidden="true"></i>
  </button>
</div>
<mat-divider></mat-divider>
<mat-dialog-content>
  <form [formGroup]="formData" #formDirective="ngForm" novalidate>
    <br />
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input">Node Name</mat-label>
        </div>
        <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
          <mat-form-field>
            <input
              type="text"
              matInput
              formControlName="nodeNameCtr"
              [(ngModel)]="nodeDetails.nodeName"
              name="NodeName"
              id="NodeName"
            />
            <mat-error *ngIf="formData.get('nodeNameCtr').hasError('required')"
              >NodeName required.</mat-error
            >
            <mat-error *ngIf="formData.get('nodeNameCtr').hasError('minlength')"
              >NodeName is too short (min 2 Characters).</mat-error
            >
            <mat-error *ngIf="formData.get('nodeNameCtr').hasError('maxlength')"
              >NodeName is too long (max 30 Characters).</mat-error
            >
            <mat-error *ngIf="formData.get('nodeNameCtr').hasError('pattern')">
              Only (& . - _ / : ,) special symbol allowed.
            </mat-error>
            <mat-error
              *ngIf="formData.get('nodeNameCtr').hasError('whitespace')"
              >Please enter valid text.</mat-error
            >
          </mat-form-field>
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input">Select Entity Type</mat-label>
        </div>
        <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
          <mat-form-field>
            <mat-select
              [(ngModel)]="nodeDetails.level"
              formControlName="level"
              ngDefaultControl
              [ngModelOptions]="{ standalone: true }"
              (selectionChange)="getEntityList()"
            >
              <mat-option>--- Select Entity Type ---</mat-option>
              <mat-option *ngFor="let item of entity" [value]="item.text">{{
                item.value
              }}</mat-option>
            </mat-select>
            <mat-error *ngIf="formData.get('level').hasError('required')"
              >Entity Type required.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input">Select Entity</mat-label>
        </div>
        <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
          <ng-container *ngIf="nodeDetails.level !== 'meter'">
            <mat-form-field>
              <mat-select
                [(ngModel)]="nodeDetails.selectedEnity"
                (ngModelChange)="getSensorsConnectedToGenericLoad()"
                formControlName="selectedEnityCtr"
                ngDefaultControl
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option>--- Select Entity ---</mat-option>

                <mat-option
                  *ngFor="let item of immediateChildEntites"
                  [value]="item.nodeId"
                  >{{ item.Title }}</mat-option
                >
              </mat-select>
              <mat-error
                *ngIf="formData.get('selectedEnityCtr').hasError('required')"
                >Entity required.</mat-error
              >
            </mat-form-field>
          </ng-container>

          <ng-container *ngIf="nodeDetails.level === 'meter'">
            <mat-form-field>
              <mat-select
                [(ngModel)]="nodeDetails.selectedLoadEntity"
                (ngModelChange)="getParameterSelectedLoad($event)"
                formControlName="selectedLoadEntityCtr"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option>--- Select Entity ---</mat-option>

                <mat-option *ngFor="let load of loads" [value]="load.loadId">
                  {{ load.name }}</mat-option
                >
              </mat-select>
              <mat-error
                *ngIf="
                  formData.get('selectedLoadEntityCtr').hasError('required')
                "
                >Entity required.</mat-error
              >
            </mat-form-field>
          </ng-container>
        </div>
        <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
      </div>
    </div>
    <div class="row" *ngIf="nodeDetails.level === 'sensor'">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
          <mat-label class="label-input">Select Sensor</mat-label>
        </div>
        <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
          <mat-form-field>
            <mat-select
              [(ngModel)]="nodeDetails.sensorRIdForSelectedEnity"
              formControlName="selectedsensorRIdCtr"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="generateNodeIdForSensor()"
            >
              <mat-option>--- Select Sensor ---</mat-option>
              <mat-option
                *ngFor="let item of sensorConnectedToGenericLoad"
                [value]="item.sensorNodeId"
                >{{ item.Title }}</mat-option
              >
            </mat-select>
            <mat-error
              *ngIf="formData.get('selectedsensorRIdCtr').hasError('required')"
              >Sensor required.</mat-error
            >
          </mat-form-field>
        </div>
      </div>
    </div>
    <div
      *ngIf="
        nodeDetails.level === 'meter' && nodeDetails.selectedLoadEntity !== ''
      "
    >
      <!--parameter-->
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">
            <mat-label class="label-input">Select Parameter</mat-label>
          </div>
          <div class="col-xs-5 col-sm-5 col-md-5 col-lg-5">
            <mat-form-field>
              <mat-select
                [(ngModel)]="nodeDetails.monitoredParameter"
                (ngModelChange)="generateMeterNoadeId()"
                formControlName="parameterType"
                [ngModelOptions]="{ standalone: true }"
              >
                <mat-option>--- Select Parameters ---</mat-option>
                <mat-option
                  *ngFor="let param of parameters"
                  [value]="param.value ? param.value : param"
                >
                  {{ param.text ? param.text : param }}
                </mat-option>
              </mat-select>
              <mat-error
                *ngIf="formData.get('parameterType').hasError('required')"
                >Parameter required.</mat-error
              >
            </mat-form-field>
          </div>
          <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3"></div>
        </div>
      </div>
    </div>
    <br />
    <mat-divider></mat-divider>
    <div class="row" style="text-align: center">
      <button
        type="button"
        class="button-primary"
        bciprimarybutton
        (click)="addNodeLabel()"
        style="margin-top: 1em"
        [disabled]="formData.invalid"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-checkmark-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
        Add Node
      </button>
      &nbsp;
      <button
        class="button-primary"
        bciprimarybutton
        (click)="delete($event)"
        [disabled]="actionMode === getActionModeEnum.Creating"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-delete"
            style="width: max-content"
          ></mat-icon>
        </span>
        Delete
      </button>
      &nbsp;
      <button
        type="button"
        class="button-primary"
        bciprimarybutton
        (click)="close(false)"
      >
        <span>
          <mat-icon
            aria-hidden="false"
            aria-label="weather icon"
            class="bosch-ic-abort-frame"
            style="width: max-content"
          ></mat-icon>
        </span>
        Close
      </button>
    </div>
  </form>
</mat-dialog-content>
